<template>
  <div v-loading="pageLoading" class="bg">
    <div class="top_div" @click="goBack">
      <i class="el-icon-arrow-left left_link"></i>测评报告
    </div>
    <div class="user_info">
      <div class="time">{{ detail.createTime }}</div>
      <div class="detail">
        <div class="ava">
          <img class="" src="@/assets/ava_man.png" />
        </div>
        <div class="content">
          <div class="line_1">
            <div>姓名：{{ patient_detail.name }}</div>
            <div>性别：{{ patient_detail.sex }}</div>
          </div>
          <div>年龄：{{ patient_detail.age }}岁</div>
        </div>
      </div>
    </div>
    <div class="line"></div>
    <div class="main_div">
      <div class="first">
        <div class="res_tags">总得分</div>
        <div class="jieshi_score_title">
          总得分：
          <span class="jieshi_score">{{ result_detail.score }}分</span>
        </div>
      </div>
      <div class="third">
        <div class="third_title">
          <img class="picture" src="@/assets/result_detail_xin.png" />
          <div class="third_text">评分标准</div>
        </div>
        <div class="card">
          <div v-for="(item, key) in result_detail.score_standard" :key="key">
            {{ item }}
          </div>
        </div>
      </div>
      <div class="fourth">
        <div class="res_tags">评分标准出处</div>
        <div class="card">
          <span v-if="detail.wenjuan_id == 2">简式健康表（BSRS-5）量表</span>
          <span v-else-if="detail.wenjuan_id == 3"
            >简易心理状况评定量表Kessler10 量表</span
          >
          <span v-else-if="detail.wenjuan_id == 4">SCL-90症状自评量表</span>
          <span v-else-if="detail.wenjuan_id == 5"
            >视觉模拟评分法(VAS)量表</span
          >
        </div>
      </div>
      <div style="margin-top: 40px; text-align: center">
        *此报告只显示测评者本次测评结果，仅供参考，并非诊断结果。
      </div>
    </div>
  </div>
</template>

<script>
import { getDetail } from "@/api/wenjuanResult";
export default {
  name: "ReportDetail",
  data() {
    return {
      id: null,
      detail: {
        createTime: "",
      },
      patient_detail: {
        name: "",
        sex: "",
        age: "",
      },
      result_detail: {
        level: "",
        level_pic: "",
        error_num: "",
        result: "",
        tips: "",
        suggest: "",
      },
      pageLoading: true,
    };
  },
  mounted() {
    //没有问卷id就去选择对应的问卷
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
    } else {
      this.go_index();
    }
    this.fetchDetail();
  },
  methods: {
    //跳转至选择病人页面
    go_choose_patient() {
      this.$router.push({
        path: "choose_patient",
      });
    },
    //点击顶部的返回按钮
    goBack() {
      let that = this;
      this.$confirm("确定要返回选择患者页面吗?", "提示", {
        confirmButtonText: "确定返回",
        cancelButtonText: "再想一想",
        type: "warning",
        buttonSize: "large",
      })
        .then(() => {
          that.go_index();
        })
        .catch(() => {});
    },
    //跳转至选择问卷页面
    go_index() {
      this.$router.push({
        path: "/",
        query: { uid: this.uid },
      });
    },
    goDetail() {
      this.$router.push({
        path: "/report_detail",
        query: { id: this.id },
      });
    },
    //获取数据详情
    async fetchDetail() {
      this.pageLoading = true;
      try {
        const {
          data: { detail, patient_detail, result_detail },
        } = await getDetail(this.id);
        this.detail = detail;
        this.patient_detail = patient_detail;
        this.result_detail = result_detail;
      } finally {
        this.pageLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.bg {
  padding-bottom: 49px;
  background-color: #379884;
  background-image: url(../../assets/report_bg.png);
  background-repeat: no-repeat;
  background-position: initial;
  background-size: inherit;
}

.top_div {
  display: flex;
  align-items: center;
  width: 100%;
  height: 131px;
  font-size: 48px;
  font-weight: bold;
  color: #fff;
}
.link_div {
  width: 50px;
}
.left_link {
  margin-left: 15px;
}
.top_title {
  flex: 1;
  text-align: center;
}

.user_info {
  width: 855px;
  padding: 45px;
  padding-bottom: 80px;
  margin: 0px auto;
  margin-top: 72px;
  background: linear-gradient(180deg, #daf7f1, #ffffff);
  border-radius: 20px 20px 0px 0px;

  .time {
    margin-bottom: 30px;
    font-size: 30px;
    font-weight: 400;
    line-height: 40px;
    color: #333333;
    text-align: right;
  }
  .detail {
    display: flex;
    align-items: center;
    font-size: 36px;
    font-weight: 400;
    line-height: 40px;
    color: #333333;
    .content {
      flex: 1;
      padding-left: 25px;
    }
    .line_1 {
      display: flex;
      justify-content: center;
      width: 100%;
      margin-bottom: 40px;
      div {
        flex: 1;
      }
    }
  }
}

.line {
  width: 945px;
  height: 21px;
  margin: 0px auto;
  background: #f2f2f2;
}
.main_div {
  width: 893px;
  padding: 39px 26px;
  margin: 0px auto;
  background: #ffffff;
  border-radius: 0px 0px 20px 20px;

  .res_tags {
    height: 62px;
    font-size: 36px;
    font-weight: 400;
    line-height: 62px;
    color: #ffffff;
    text-align: center;
    background: #00ba88;
    border-radius: 20px 20px 0px 0px;
  }
  .card {
    display: flex;
    justify-content: space-between;
    padding: 75px 25px;
    font-size: 36px;
    font-weight: 400;
    line-height: 44px;
    color: #606266;
    background: #ffffff;
    border-radius: 10px;
    box-shadow: 0px 15px 30px 2px rgba(167, 189, 183, 0.21);
  }

  .first {
    .res_tags {
      width: 196px;
    }
    .jieshi_score_title {
      margin-top: 40px;
      // padding-left: 60px;
      font-size: 39px;
      font-weight: 400;
      line-height: 44px;
      color: #606266;
      text-align: center;
    }
    .jieshi_score {
      font-size: 39px;
      font-weight: 400;
      line-height: 44px;
      color: #f56c6c;
    }
    .first_result {
      padding-left: 97px;
      margin-top: 57px;
      font-size: 39px;
      font-weight: 400;
      line-height: 44px;
      color: #606266;
      text-align: left;
    }
    .first_result_color {
      font-size: 52px;
      font-weight: 400;
      color: #c0e13a;
    }
    .first_result_color_red {
      font-size: 52px;
      font-weight: 400;
      color: #fdc600;
    }
  }
  .result_jieshi {
    .jieshi_title {
      display: flex;
      padding-top: 43px;
      padding-bottom: 36px;
      .picture {
        width: 52px;
        height: 52px;
      }
      .jieshi_text {
        margin-left: 16px;
        font-size: 40px;
        font-weight: bold;
        line-height: 44px;
        color: #333333;
      }
    }

    .jieshi_suggest {
      width: 701px;
      padding: 43px 39px;
      margin: 0px auto;
      margin-top: 27px;
      font-size: 33px;
      font-weight: 400;
      line-height: 45px;
      color: #606266;
      background: #f0f4f3;
      border-radius: 10px;
    }
    .tips {
      margin-top: 31px;
      font-size: 30px;
      font-weight: 400;
      line-height: 42px;
      color: #999999;
      text-align: center;
    }
  }
  .second {
    margin-top: 51px;
    .res_tags {
      width: 271px;
    }
    .secont_title {
      display: flex;
      padding-top: 43px;
      padding-bottom: 36px;
      .picture {
        width: 52px;
        height: 52px;
      }
      .secont_text {
        margin-left: 16px;
        font-size: 40px;
        font-weight: bold;
        line-height: 44px;
        color: #333333;
      }
    }

    .secont_list {
      width: 779px;
      margin: 0px auto;
      .secont_item {
        display: flex;
        align-items: center;
        height: 120px;
        padding-right: 32px;
        padding-left: 39px;
        margin-bottom: 18px;
        font-size: 37px;
        font-weight: 400;
        line-height: 40px;
        color: #606266;
        background: #f0f4f3;
        border-radius: 10px;
        .secont_item_title {
          flex: 1;
        }
        .secont_value {
          width: 90px;
        }
        .red {
          color: #f56c6c;
        }
        .secont_status {
          width: 30px;
          margin-left: 10px;
        }
      }
    }
  }
  .third {
    margin-top: 50px;
    .res_tags {
      width: 136px;
    }

    .third_title {
      display: flex;
      padding-top: 43px;
      padding-bottom: 36px;
      .picture {
        width: 52px;
        height: 52px;
      }
      .third_text {
        margin-left: 16px;
        font-size: 40px;
        font-weight: bold;
        line-height: 44px;
        color: #333333;
      }
    }

    .card {
      display: block;
      width: 776px;
      padding: 42px 25px;
      margin: 0px auto;
      font-size: 36px;
      line-height: 62px;
      color: #606266;
    }
  }
  .fourth {
    margin-top: 50px;
    .res_tags {
      width: 256px;
    }
  }
}
</style>
